export const SET_FRANCHISE_SLUG = "SET_FRANCHISE_SLUG";
export const SET_FRANCHISE_BRANDING = "SET_FRANCHISE_BRANDING";
export const SET_FRANCHISE_LOADING = "SET_FRANCHISE_LOADING";
export const SET_FRANCHISE_ERROR = "SET_FRANCHISE_ERROR";
